import React, { useRef } from 'react';

export interface DeferredProps {
  readonly shown: boolean;
  fallback?: React.JSX.Element;
  children(shown: boolean): React.JSX.Element | null;
}

const Deferred: React.FC<DeferredProps> = ({ shown, children, fallback }) => {
  const shownRef = useRef(shown);
  if (shown) {
    shownRef.current = true;
  }

  if (shownRef.current) {
    return children(shown);
  } else {
    return fallback ?? null;
  }
};

export default Deferred;
